export const SwipeLeftMixin = {
    data() {
      return {
        startX: 0, // Posición inicial X
        startY: 0, // Posición inicial Y
      };
    },
    methods: {
      onTouchStart(event) {
        this.startX = event.touches[0].clientX;
        this.startY = event.touches[0].clientY;
      },
      onTouchMove(event) {
        const currentX = event.touches[0].clientX;
        const currentY = event.touches[0].clientY;
        const deltaX = currentX - this.startX;
        const deltaY = currentY - this.startY;
  
        if (deltaX < -50 && Math.abs(deltaX) > Math.abs(deltaY)) {
          this.handleSwipeLeft();
        }
      },
      onTouchEnd() {
        this.startX = 0;
        this.startY = 0;
      },
    },
  };
  